import React, { useEffect, useState } from 'react';
import useIsMobile from '../../hooks/useIsMobile';

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpenDesktop?: boolean;
  defaultOpenMobile?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  defaultOpenDesktop = true,
  defaultOpenMobile = false
}) => {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState<boolean>(isMobile ? defaultOpenMobile : defaultOpenDesktop);

  useEffect(() => {
    setOpen(isMobile ? defaultOpenMobile : defaultOpenDesktop);
  }, [isMobile, defaultOpenDesktop, defaultOpenMobile]);

  return (
    <div
      style={{
        border: `1px solid var(--color-border, #e5e7eb)`,
        borderRadius: '20px',
        backgroundColor: '#fff',
        marginBottom: '16px'
      }}
    >
      <button
        onClick={() => setOpen(prev => !prev)}
        style={{
          width: '100%',
          padding: '12px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'none',
          border: 'none',
          fontSize: '14px',
          fontWeight: 700,
          cursor: 'pointer'
        }}
      >
        <span>{title}</span>
        <span
          style={{
            display: 'inline-flex',
            transition: 'transform 0.2s ease',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
          }}
        >
          ▾
        </span>
      </button>
      {open && <div style={{ padding: '16px' }}>{children}</div>}
    </div>
  );
};

export default Accordion;
